import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import AddLanguageModal from './AddLanguageModal';
import LanguagesTable from './LanguagesTable';
import LanguagesPageShell from './LanguagesPageShell';
import {
  setLanguages,
  deleteLanguage,
  setAvailableLanguages,
  setDefaultLanguage,
} from './actions';
import { updateLanguage } from './apis';
import { useUpdateEvent } from '../hooks';
import env from '../../../config/env';
import AiTemplateLanguage from '../../AiTemplate/Language';

const LanguagesSwitch = (props) => (
  env.isSelfieCam() ? <AiTemplateLanguage /> : <LanguagesOriginal {...props} />
);

const LanguagesOriginal = ({
  event,
  languages,
  availableLanguages,
  defaultLanguage,
  setLanguagesAction,
  setDefaultLanguageAction,
  setAvailableLanguagesAction,
}) => {
  const isEventUpdating = useUpdateEvent();
  const [tableKey, setTableKey] = useState(0);

  const updateEventHandler = async (eventIds) => {
    try {
      const response = await updateLanguage({
        eventIds,
        languages,
        availableLanguages,
        defaultLanguage,
      });
      const {
        languages: updatedLanguages,
        availableLanguages: sortedLanguages,
        defaultLanguage: newDefaultLanguage,
      } = response;
      if (!updatedLanguages || !sortedLanguages || !newDefaultLanguage) {
        throw new Error('Unexpected API response');
      }

      setAvailableLanguagesAction(response.availableLanguages);
      setDefaultLanguageAction(response.defaultLanguage);
      setLanguagesAction(response.languages);
      setTableKey((prev) => prev + 1);
    } catch (error) {
      console.error('Failed to update event:', error);
      throw error;
    }
  };

  useEffect(() => {
    if (event && !isEventUpdating) {
      const {
        languages: eventLanguages,
        availableLanguages: eventAvailableLanguages,
        defaultLanguage: eventDefaultLanguage,
      } = event;
      if (eventLanguages && eventAvailableLanguages && eventDefaultLanguage) {
        setAvailableLanguagesAction(eventAvailableLanguages);
        setDefaultLanguageAction(eventDefaultLanguage);
        setLanguagesAction(eventLanguages);
      }
    }
  }, [event, isEventUpdating]);

  return (
    <LanguagesPageShell loading={isEventUpdating} updateHandler={updateEventHandler}>
      <LanguagesTable key={tableKey} />
      <AddLanguageModal />
    </LanguagesPageShell>
  );
};

export default connect(
  ({
    events: { selectedEvents },
    languages: { languages, availableLanguages, defaultLanguage },
  }) => ({
    event: selectedEvents[0],
    languages,
    availableLanguages,
    defaultLanguage,
  }),
  {
    setLanguagesAction: setLanguages,
    setDefaultLanguageAction: setDefaultLanguage,
    setAvailableLanguagesAction: setAvailableLanguages,
    deleteLanguageAction: deleteLanguage,
  },
)(LanguagesSwitch);
